/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Collapse,
  Divider,
  HStack,
  Heading,
  IconButton,
  Menu,
  MenuButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Spinner,
  Stack,
  Text,
  useDisclosure,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { SearchContext } from '../context';
import { SearchArticlesFilters } from './filters';
import { SearchArticlesListing } from './listing';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import { isMobile } from 'react-device-detect';
import { Filters } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
// import { useDisclosure } from '@mybridge/ui';
export const SearchArticles = forwardRef(
  ({ count, listing, ...props }, ref) => {
    const {
      articlesSearchIsFetching,
      articlesTotalCount,
      query,
      articlesSearchIsLoading,
    } = useContext(SearchContext);
    const filterDisc = useDisclosure();
    const { t } = useTranslator();
    return (
      // <Box w="100%">
      <Stack>
        {query?.query?.length && isMobile ? (
          <Collapse style={{overflow:"inherit"}} in={filterDisc?.isOpen} animateOpacity>
            <SearchArticlesFilters />
            <Divider my={2} />
          </Collapse>
        ) : (
          ''
        )}
        <Stack spacing={0}>
          <HStack
            w="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={0}
          >
            <Heading as="h1" pl={2} fontSize="20px" color="brandPrimary.500" fontWeight="400">
              {t('navigation.articles') || "Articles"}
            </Heading>
            {articlesSearchIsFetching ? <Spinner /> : ''}
            {isMobile && <IconButton icon={<Filters />} onClick={() => filterDisc.onToggle()} variant="transparent" />}
          </HStack>
          {query?.query?.length && articlesTotalCount ? (
            <Text pl={2} size="sm">{articlesTotalCount} {t('pageJobs.results') || "results"}</Text>
          ) : (
            ''
          )}
        </Stack>
        <SearchArticlesListing fromSeperateList={true} fromIndex={true} />
        {/* {articlesHasNextPage ? (
          <Button
            isLoading={articlesSearchIsFetching}
            onClick={articlesFetchNextPage}
          >
            Load More
          </Button>
        ) : (
          ''
        )} */}
      </Stack>
      // </Box>
    );
  }
);
